<template>
  	<div  >
 		<CanvasData @dataChange="doChange" ref="canvas" :imageSize="imageSize" :imageSrc="source" :pos="{x:shipX,y:shipY}" style="width:100%;position:absolute;left:0px;">  </CanvasData>
         <div class="testSpot" :style="'left:'+(shipX)+'px;top:'+(shipY)+'px;'"></div>
         <div class="debug" style="top:0px;">I:{{isInside}} ~ D:{{dir}} ~ S:{{searching}} ~ BC:{{bottomCorner}}

        <br> {{polygon}} {{shipX}},{{shipY}}
         </div>

         <svg :width="imageSize.w" :height="imageSize.h">
    <polygon :points="polygon"></polygon>
   
  </svg>
  {{polygon}}
 	</div>
</template>

<script>
const width = window.innerWidth;
const height = window.innerHeight;
import gsap from "gsap";
import CanvasData from '@/components/CanvasData'


var classifyPoint = require("robust-point-in-polygon")

export default {
    components:{
        CanvasData,

    },
    props:{
       source:null,
        polygon:{
            type: Array,
            default: () => ([
                [ 240, 50 ], [ 400, 150 ], [ 450, 300 ], [ 260, 400 ]
            ])
        }   
    },
    
  data() {
      var left=300
    return {
        bmData:null,
        animFrame:null,
        timeOut:null,
        canvas:null,
        context:null,
        imageData:null,
        image: null,
        shipX:0,
        shipY:0,
        shipD:0,
        searching:false,
        doMove:false,
        moveSpeed:10,
       imageSize:{w:864,h:540},
       polygon2 :[ [ 240+left, 50 ], [ 400+left, 150 ], [ 450+left, 300 ], [ 260+left, 400 ] ],
       sortedPoly:null,
       bottomCorner:null,
       topCorner:null,
       scannedData:[],
       foundData:[],
       pollyInit:false,
  
    };
  },
  mounted() {
      
  }, 
  computed:{
      scanData(){

        return this.$store.getters.getScanData
    },
      dir(){
          if(this.shipD>0){
              return "DOWN"
          }else{
              return "UP"
          }
      },
      isInside(){
          
          if(this.inside==-1){
              return false
          }else{
              return true
          }
      },
    inside(){
        for(var i in this.polygon ){
            if(this.polygon[i][0]==this.shipX && this.polygon[i][1]==this.shipY){
                return 0

            }
          }
        return  -classifyPoint(this.polygon, [this.shipX,this.shipY])
    }
  },
  methods:{
      startScan(){
          //return
          this.initPoly()
          
          this.scannedData=[]

          this.doScan()
      },
      stopScan(){
          if(this.timeOut){
            clearTimeout(this.timeOut)
          }
      },
      initPoly(){
        this.pollyInit=true
        this.sortPoly()
        this.searching=false,
        this.shipX=this.sortedPoly[0][0]
        this.shipY=this.sortedPoly[0][1]
        if(this.sortedPoly[0][1]<this.sortedPoly[1][1]){
            this.shipD=1
        }else{
            this.shipD=-1
        }
     
      },
      sortPoly(){
          
          this.topCorner=this.polygon[0][1]
          this.bottomCorner=this.polygon[0][1]
          for(var i in this.polygon ){
              if(this.polygon[i][1]<this.topCorner){
                  this.topCorner=this.polygon[i][1]
              }
              if(this.polygon[i][1]>this.bottomCorner){
                  this.bottomCorner=this.polygon[i][1]
              }
          }
          this.sortedPoly=this.polygon.slice(0).sort(function(a,b) {
            if( a[0] == b[0]) return a[1]-b[1]
            return a[0]-b[0];
        });
         
      },
      doScan(){
      
        this.sortPoly()
        var finished=false
        
            let scanData=this.scanData
           
           
            while (!finished ){
               // count++
                
                  // scanData=this.scanData
                scanData=this.$refs.canvas.getData(this.shipX,this.shipY)
                  if(!scanData){
                    alert("No scan Data")
                    this.$nextTick(() => {
                         scanData=this.$refs.canvas.getData(this.shipX,this.shipY)
                         console.log("scanData B",this.$refs.canvas,this.shipX,this.shipY,this.$refs.canvas.getData(this.shipX,this.shipY))
                 alert("No scan Data 2")
                     })
                    return
                }
                //if location found
                let findIndex=-1
                if(scanData.r>100 ){
                     findIndex=-1
                    for(var f in this.foundData){
                        if(this.foundData[f].r==scanData.r){
                            findIndex=f
                        }
                    }
                    if(findIndex==-1) {
                        findIndex=this.foundData.length
                        scanData.revealed=false
                        this.foundData.push(scanData)

                    }
                    //this.$emit("FoundSomething",scanData.r,scanData.x,scanData.y)
                } 
                // Check over water
                if(scanData.b>100){
                     this.scannedData.push({x:this.shipX,y:this.shipY,r:scanData.r,r:scanData.b,findIndex:findIndex})
                }
                // change direction to keep in search area 
                if(!this.isInside ){
                    if(!this.searching){
                        this.shipX+=10;  
                        this.shipD=-this.shipD
                        this.searching=true
                    }else{
                        this.shipY+=this.shipD*10
                    }
                }else{
                    this.shipY+=Math.floor(this.shipD*.5*this.moveSpeed)
                    this.searching=false
                }
                if(this.dir=="DOWN" && this.shipY>this.bottomCorner){
                            this.shipD=-1
                            this.shipX++
                }
                if(this.dir=="UP" && this.shipY<this.topCorner){
                            this.shipD=1
                            this.shipX++
                }
                // finished searching
                if(this.shipX>=this.sortedPoly[this.sortedPoly.length-1][0]){
                    this.doMove=false
                    this.$emit("preScanFinished")
                    console.log("PRE SCAN FINISHED")
                    finished=true
                    //console.log( this.scannedData)
                    console.log("FOUND",this.foundData,this.scannedData)
                    
                    this.$store.commit('setFoundData',this.foundData)
                    this.$store.commit('setScannedData',this.scannedData)
                }
                
            }
        
       
      },
       doChange(val){
           this.bmData=val
           if(this.searching){
                this.$emit("searchUpdate",val.r,this.shipX,this.shipY)
           }
           if(val.r>20 && this.searching){
               //this.doMove=false
               this.$emit("FoundSomething",val.r,this.shipX,this.shipY)
               
           }
       },
     
   
  },
  watch:{
    
    polygon(){
        this.initPoly()
    }
  }
};
</script>


   

<style lang="scss">
svg { 
    display: block; 
    position:absolute;
    z-index:1;
    top:0px;
    left:0px;
}
polygon { fill: #00ff0099; }
.testSpot{
    width:20px;
    height:20px;
    position:absolute;
    top:0px;
    left:0px;
    border-radius:50%;
    border: #fff solid 10px;
}

</style>